module.exports = __webpack_public_path__ + "static/media/3.ce05a568.jpg";